import { render } from "./ReferralSourceInformation.vue?vue&type=template&id=e97b5de8&ts=true"
import script from "./ReferralSourceInformation.ts?vue&type=script&lang=ts&external"
export * from "./ReferralSourceInformation.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__